/**
 * Decodes a JWT token payload in a base64url-safe manner.
 * Standard `atob` can fail on base64url-encoded strings that contain `-` or `_`
 * characters or have missing padding. This helper normalises both before decoding.
 *
 * @param {string} token - A JWT string (header.payload.signature)
 * @returns {object|null} The decoded payload object, or null if decoding fails.
 */
export function decodeJwtPayload(token) {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}
